/* eslint-disable */
import React, { PropTypes } from 'react';
import Alarm from './iconesTimeLine/Alarm'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import './css/VerticalTimeline.css';
import './css/VerticalTimelineElement.css';
import './css/timeLine.css';
import ConfigD from './util/ConfigD';

import moment from 'moment';


class TimeLineItem extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            painelAberto:false
        };

        this.abrirPanel = this.abrirPanel.bind(this);
        this.abrirSolicitarInformacao = this.abrirSolicitarInformacao.bind(this);
    }

    abrirPanel(event) {
        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        this.props.abrirPanel(this.props.mensagem, this.props.historico, this.props.texto);
    }

    abrirSolicitarInformacao(event) {
        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.props.abrirPanel(this.props.mensagem, this.props.historico, this.props.texto);
    }

    componentDidMount() {
        
        if (this.props.historico.mSituacao.mIdSituacao === 9
            && this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length - 1].mSituacao.mIdSituacao === 9 &&
            this.props.historico.mIdHistoricoMensagem === this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length-1].mIdHistoricoMensagem ) {
                
                if(!this.state.painelAberto){
                    this.props.abrirPanel(this.props.mensagem, this.props.historico, this.props.texto);                
                    this.setState({painelAberto:true})
                }
            }
    }

    render() {
        
        var apresentarTexto = '';
        var apresentarLink = null;
        if (this.props.historico.mVisivelExterno){
            apresentarTexto = <div dangerouslySetInnerHTML={{ __html: this.props.texto }}/>;
            apresentarLink = <p><a href='javascript:' onClick={this.abrirPanel}>Ler mais</a></p>
        }
        //console.log('histórico - ', this.props.historico);
        //console.log('mensagem - ', this.props.mensagem);
        var anexosCadastrada='';
        if (this.props.historico.mSituacao.mIdSituacao === 1 || this.props.historico.mSituacao.mIdSituacao === 10) {
            debugger
            if (this.props.historico !== null && this.props.historico.mArquivosAnexados!=null && this.props.historico.mArquivosAnexados.length > 0) {
                var visivel = false;
                for (let index = 0; index < this.props.historico.mArquivosAnexados.length; index++) {
                    if (this.props.historico.mArquivosAnexados[index].mVisivelUsuario) {
                        visivel = true;
                        break;
                    }
                }
                if (visivel) {
                    anexosCadastrada = (
                        <div>
                            <hr />
                            <div className='rowCardAnexo '><strong>Tem anexo para você visualizar:</strong></div>
                            <ul>
                            {
                                this.props.historico.mArquivosAnexados.map((anexo, index) => {
                                    if (anexo !== null && anexo.mVisivelUsuario) {
                                        return <div  key={index}><li key={index} className='anexos'><a href={ ConfigD.getDownloadArquivoURL(anexo.mMD5Hash, anexo.mFileName) }>{anexo.mFileName}</a></li></div>
                                    }
                                })
                            }
                            </ul>
                        </div>
                    )
                }
            }
        }

        var anexosFinalizada = '';
        if (this.props.historico.mSituacao.mIdSituacao === 3) {
            if (this.props.mensagem.mArquivosAnexados !== null && this.props.mensagem.mArquivosAnexados.length>0) {
                var visivel= false;
                for (let index = 0; index < this.props.mensagem.mArquivosAnexados.length; index++) {
                    if (this.props.mensagem.mArquivosAnexados[index].mVisivelUsuario){
                        visivel = true;
                        break;
                    }
                }                
                if(visivel){
                    anexosFinalizada = (
                        <div>
                            <hr />
                            <div className='rowCardAnexo '><strong>Tem anexo para você visualizar:</strong></div>
                            <ul>
                            {
                                this.props.mensagem.mArquivosAnexados.map((anexo, index) => {
                                    if (anexo !== null && anexo.mVisivelUsuario) {
                                        return <div  key={index}><li key={index} className='anexos'><a href={ConfigD.getDownloadArquivoURL(anexo.mMD5Hash, anexo.mFileName) }>{anexo.mFileName}</a></li></div>
                                    }
                                })
                            }
                            </ul>
                    </div>
                    )
                }
            }
            if (this.props.historico.mArquivosAnexados !== null && this.props.historico.mArquivosAnexados.length>0) {
                var visivel= false;
                for (let index = 0; index < this.props.historico.mArquivosAnexados.length; index++) {
                    if (this.props.historico.mArquivosAnexados[index].mVisivelUsuario){
                        visivel = true;
                        break;
                    }
                }                
                if(visivel){
                    anexosFinalizada = (
                        <div>
                            <hr />
                            <div className='rowCardAnexo '><strong>Tem anexo para você visualizar:</strong></div>
                            <ul>
                            {
                                this.props.historico.mArquivosAnexados.map((anexo, index) => {
                                    if (anexo !== null && anexo.mVisivelUsuario) {
                                        return <div  key={index}><li key={index} className='anexos'><a href={ConfigD.getDownloadArquivoURL(anexo.mMD5Hash, anexo.mFileName) }>{anexo.mFileName}</a></li></div>
                                    }
                                })
                            }
                            </ul>
                    </div>
                    )
                }
            }
        }
        // se for informação solicitada
        // console.log('this.props.historico.mSituacao.mIdSituacao ', this.props.historico.mSituacao.mIdSituacao);
        // console.log('count de históricos ', this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length-1].mIdHistoricoMensagem);
        var informacaoSolicitada = '';
        
        console.log('this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length - 1].mSituacao ', this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length - 1].mSituacao)
        console.log('this.props.historico.mIdHistoricoMensagem ', this.props.historico.mIdHistoricoMensagem)
        console.log('this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length-1].mIdHistoricoMensagem ', this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length-1].mIdHistoricoMensagem)
        if (this.props.historico.mSituacao.mIdSituacao === 9
            && this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length - 1].mSituacao.mIdSituacao === 9 &&
            this.props.historico.mIdHistoricoMensagem === this.props.mensagem.mHistoricos[this.props.mensagem.mHistoricos.length-1].mIdHistoricoMensagem 
        ){
            informacaoSolicitada = <div className='rowCard '><button type="submit" className='btn-sm btnCard' onClick={this.abrirSolicitarInformacao}>Complementar informação</button></div>
        }
        return (

            <div>
                <VerticalTimelineElement
                    className={this.props.classe}
                    date={moment(this.props.historico.mDataEnvio).format('DD/MM/YYYY HH:mm:ss')}
                    iconStyle={(this.props.historico.mSituacao.mIdSituacao === 1 && this.props.historico.mMovimentacaoMensagem === 0) || this.props.historico.mSituacao.mIdSituacao === 10  ? this.props.estiloCliente : this.props.estiloOuvidoria }
                    position={this.props.position}
                    animate={true}
                >
                    <h3 className="vertical-timeline-element-title">{this.props.historico.mSituacao.mDescricao}</h3>
                    {apresentarTexto}
                    {apresentarLink}
                    {anexosCadastrada}
                    {anexosFinalizada}
                    {informacaoSolicitada}
                </VerticalTimelineElement>
                <br/>
            </div>
        );
    }
}


export default TimeLineItem;



/** WEBPACK FOOTER **
 ** ./src/components/TimeLineItem.js
 **/